export enum Region {
  EU = 'eu',
  US = 'us',
  REST_OF_WORLD = 'rest_of_world',
}
